import { InfoCircle } from 'react-bootstrap-icons';

export function QuoteDisplay({ withAttorney, withoutAttorney }) {
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    return (
        <div className="quote-display">
            <h4 className="quote-display-title">Your Estimated Claim Value</h4>

            <div className="quote-card quote-card-basic">
                <div className="quote-card-label">Without Attorney</div>
                <div className="quote-card-value">
                    {currencyFormatter.format(withoutAttorney)}
                </div>
            </div>

            <div className="quote-card quote-card-attorney">
                <div className="quote-card-badge">Recommended</div>
                <div className="quote-card-label">With Attorney</div>
                <div className="quote-card-value">
                    {currencyFormatter.format(withAttorney)}
                    <span className="quote-card-plus"> or more</span>
                </div>
            </div>

            <div className="quote-disclaimer">
                <InfoCircle size={14} />
                <span>For informational purposes only. Results vary based on coverage and representation.</span>
            </div>
        </div>
    );
}